import { Link } from 'react-router-dom';
import { seoSections } from '@/mocks/seoContent';

export default function BottomContent() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
            {seoSections.bottomContent.title}
          </h2>
          {seoSections.bottomContent.paragraphs.map((p, idx) => (
            <p key={idx} className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              {p}
            </p>
          ))}

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {seoSections.features.map((feature) => (
              <div
                key={feature.title}
                className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/50"
              >
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-check-line text-accent-600 text-lg"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-14 p-6 md:p-8 bg-background-100 rounded-2xl border border-background-200/70">
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-4">
              Explore Related Spreadsheet Resources
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
              {[
                { label: 'Kakobuy Spreadsheet', desc: 'Alternative guide' },
                { label: 'CSSBuy Spreadsheet', desc: 'Complete overview' },
                { label: 'Superbuy Spreadsheet', desc: 'Review & tips' },
                { label: 'Oopbuy Spreadsheet', desc: 'Getting started' },
                { label: 'Hipobuy Guide', desc: 'Full tutorial' },
              ].map((item) => (
                <Link
                  key={item.label}
                  to="/hipobuy-spreadsheet-guide"
                  className="p-4 rounded-lg bg-background-50 border border-background-200/50 hover:border-accent-300 transition-colors text-center"
                >
                  <div className="text-sm font-semibold text-foreground-900 mb-1">
                    {item.label}
                  </div>
                  <div className="text-xs text-foreground-400">
                    {item.desc}
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="mt-10 text-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center space-x-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              <span>Hipobuy Sheet</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}